// extracted by mini-css-extract-plugin
export var button = "_md-0";
export var donut = "_md-1";
export var donutFill = "_md-3";
export var donutTrack = "_md-2";